import { LinearProgress, Typography, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/system';

export const TaskProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 26,
  flex: 1,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 30,
    backgroundColor: theme.palette.accent.main,
  },
}));

export const TaskProgressText = styled(Typography)({
  fontSize: '0.625rem',
  fontWeight: 400,
  color: '#010203',
  minWidth: 28,
  textAlign: 'right',
});
